exports.LANGUAGES = {
    SPANISH: 'es',
    ENGLISH: 'en',
    PORTUGUESE: 'pt',
}

exports.LANGUAGES_VALUES = [
    { value: 'pt', name: 'PT' },
    { value: 'es', name: 'ES' },
    { value: 'en', name: 'EN' }
];